// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/atc-service-categories.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/atc-service-categories/atc-service-categories.js';
import g1 from '../lessons/air-law/atc-service-categories/atc-terminology.js';

mount([g0, g1]);
